module.exports = __webpack_public_path__ + "static/media/PICT0071(1)-01.913946c8.jpg";